export const urlSuParametrais = (handler, parameters, path = null) => {
  let url = path ? `${handler}/${path}` : handler;

  const params = new URLSearchParams();

  for (let i = 0; i < parameters.length; i++) {
    const { parameter, condition, append, value } = parameters[i];

    // Check the condition using eval (be careful with this approach)
    let conditionMet = false;
    let valueToCompare;

    switch (condition) {
      case "false":
        conditionMet = parameter === false;
        break;
      case "add":
        conditionMet = true;
        break;
      case "true":
        conditionMet = parameter === true;
        break;
      case "!==0":
        valueToCompare = condition.split("!==")[1].trim();
        conditionMet = parameter !== Number(valueToCompare);
        break;
      case "more than 0":
        conditionMet = value > 0;
        break;
      case "less than 1000":
        conditionMet = value < 1000;
        break;
      case "less than 2000":
        conditionMet = value < 2000;
        break;
      case "===":
        valueToCompare = condition.split("===")[1].trim();
        conditionMet = parameter === Number(valueToCompare);
        break;
      case "!null":
        conditionMet = parameter;
        break;
      case "length === 1":
        conditionMet = Array.isArray(parameter) && parameter.length === 1;
        break;
      case "months range":
        conditionMet = parameter >= 1 && parameter <= 10;
        break;
      case "!==null":
        conditionMet = parameter !== null;
        break;
      default:
        conditionMet = false;
    }

    if (conditionMet) {
      params.append(append, value);
    }
  }

  const queryString = params.toString();

  if (queryString) {
    url += `?${queryString}`;
  }

  return url;
};
